<script>
  import LanguageDropdown from "../../common/LanguageDropdown.svelte";
  import { Link } from "svelte-routing";
  import {
    Container,
    Row,
    Col,
    CardBody,
    Card,
    Button,
    Label,
    Input,
    Form,
  } from "sveltestrap";

  import { onMount } from 'svelte';

  let code = '';
  let data = '';
  let newPassword= '';
  let confirmPassword= '';
  async function getData(){
		let location = 'es-CL'
		location = await localStorage.getItem('LANGUAGE');
		if( location=="es"){
			location='es-CL';
		}
		var requestOptions = {
		method: 'GET',
		redirect: 'follow'
		};
		fetch(`https://api.rastros.cl/api/recovery-change-pass-page?populate=%2A&locale=${location}`, requestOptions)
		.then(response => response.json())
		.then(result => {
			data = result.data;
			localStorage.setItem('authUser', JSON.stringify(data));
		})
		.catch(error => console.log('error al contactar al servicio: ', error));
	}

  onMount(async () => {
    await getData();
    const urlParams = new URLSearchParams(window.location.search);
    code = urlParams.get('code');
  });

  async function handleSubmit() {
  
    var requestOptions = {
    method: "POST",
    redirect: 'follow',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      password: newPassword,
      passwordConfirmation: confirmPassword,
      code: code
    })
  };

  try {
    console.log(JSON.stringify(body));
    const response = await fetch("https://api.rastros.cl/api/auth/reset-password", requestOptions);

    if (!response.ok) {
      const errorResponse = await response.json();
      console.log(errorResponse);
      alert('Hubo un error con la solicitud. Por favor, intenta nuevamente.');
      return; 
    }

    const data = await response.json();
    navigate(data.confirmButtonLink);
  } catch (error) {
    console.error("Error al realizar la solicitud:", error);
  }
}
</script>

<div class="account-pages my-5 pt-sm-5">
  <Container>
    <Row class="justify-content-center">
      <Col md="8" lg="6" xl="5">
        <Card class="overflow-hidden">
          <div class="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{data.title}</h5>
                  <p>{data.subtitle}</p>
                </div>
              </Col>
              <Col xs="5" class="align-self-end">
                <LanguageDropdown  on:chageLang={getData}/>
                <img
                  src="assets/images/profile-img.png"
                  alt=""
                  class="img-fluid"
                />
              </Col>
            </Row>
          </div>
          <CardBody class="pt-0">
            <div>
              <Link to={data.confirmButtonLink}>
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    {#if data && data.logo && data.logo.url}
                        <img
                        src={data.logo.url}
                        alt=""
                        class="rounded-circle"
                        height="34"
                      />
                    {/if}
                  </span>
                </div>
              </Link>
            </div>
            <div class="p-2">
              <Form on:submit={handleSubmit}>
                <div class="mb-3">
                  <Label for="userpassword">{data.newPasswordLabel}</Label>
                  <Input
                    bind:value={newPassword}
                    type="password"
                    class="form-control"
                    id="userpassword"
                    placeholder={data.newPasswordPlaceholder}
                  />
                </div>
                <div class="mb-3">
                  <Label for="userpassword">{data.confirmPasswordLabel}</Label>
                  <Input
                    bind:value={confirmPassword}
                    type="password"
                    class="form-control"
                    id="userpassword"
                    placeholder={data.confirmPasswordPlaceholder}
                  />
                </div>
                <div class="text-end">
                    <Button
                      color="primary"
                      class="w-md waves-effect waves-light"
                      type="submit">{data.confirmButton}
                    </Button>
                </div>
              </Form>
            </div>
          </CardBody>
        </Card>
        <div class="mt-5 text-center">
         
          <p>
            © {new Date().getFullYear()} {data.copyright}
          
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</div>

